<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Acknowledgements</p>
<p class="list">•   Hope Nelson, my lovely bride, my best friend and my partner in crime.</p>
<p class="list">•   George Combs, for helping me navigate Alexandria Local History Special Collections.</p>
<p class="list">•   Julie Downie, for helping me translate Victorian euphemisms.</p>
<p class="list">•   Mary Fishback, for helping me navigate the Thomas Balch Library.</p>
<p class="list">•   Ruth Lincoln Kaye, for spreading an infectious interest in hidden history.</p>
<p class="list">•   Ted Pulliam, for helping me whip this wicked project into shape.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?04f229d6